module.exports = __webpack_public_path__ + "img/2245c26.webp";